<script>
import Select from "@local/components/form/Select.svelte"
import Icon from "@local/components/images/Icon.svelte"
import * as XLSX from "xlsx"

export let selectedTags
export let schedulesTakenByTag

function downloadXLSX() {
  if (!schedulesTakenByTag || schedulesTakenByTag.length === 0) return

  let filteredSchedules = schedulesTakenByTag

  if (selectedTags && selectedTags.length > 0) {
    filteredSchedules = schedulesTakenByTag.filter((tagGroup) =>
      selectedTags.includes(tagGroup.tags[0].label)
    )
  }

  const allSchedules = filteredSchedules.flatMap(
    (tagGroup) => tagGroup.schedules
  )

  if (allSchedules.length === 0) return

  const extractedData = allSchedules.map((schedule) => {
    const workflow = schedule.workflow || {}
    return {
      firstName: workflow.firstName || "",
      lastName: workflow.lastName || "",
      healthCardNumber: workflow.healthCardNumber || "",
      healthCardVersionCode: workflow.healthCardVersionCode || "",
      healthCardExpirationDate: workflow.healthCardExpirationDate || "",
    }
  })

  const headers = [
    "firstName",
    "lastName",
    "healthCardNumber",
    "healthCardVersionCode",
    "healthCardExpirationDate",
  ]

  const displayHeaders = [
    "First Name",
    "Last Name",
    "Health Card #",
    "Health Card Version Code",
    "Health Card Expiration Date",
  ]

  // Cria os dados para o Excel
  const data = extractedData.map((item) =>
    headers.map((header) => item[header])
  )

  const worksheet = XLSX.utils.aoa_to_sheet([displayHeaders, ...data])
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Schedules")

  const fileName = `schedules_${new Date().toISOString().split("T")[0]}.xlsx`
  XLSX.writeFile(workbook, fileName)
}
</script>

<div class="{$$props.class || ''}">
  <button
    class="flex items-center justify-center flex-shrink-0 w-10 h-10 btn btn-outline"
    type="button"
    title="Download XLSX"
    on:click="{downloadXLSX}"
  >
    <Icon size="3xl">download</Icon>
  </button>
</div>
